import cn from 'classnames';
import { FC, ReactNode } from 'react';

import styles from './InfoBannersGroup.module.scss';

type InfoBannersGroupProps = {
  children: ReactNode;
  className?: string;
};

export const InfoBannersGroup: FC<InfoBannersGroupProps> = (props) => {
  const { children, className } = props;

  return <div className={cn(styles.container, className)}>{children}</div>;
};
